import React, { Fragment } from "react"
import { OrderCostSummaryV2PdfProps } from "../index";
import { formatBinaryCapacityUnit, formatInteger } from "../../../../../utils/Format";
import LineItem from "../LineItem";
import { totalEpu } from "../../../../../utils/Cost";

const VolumeSummary = (props: OrderCostSummaryV2PdfProps) => {
  const { cost, styles } = props;
  const { total_cost } = cost.data;

  if (!total_cost) {
    return null;
  }

  return (
    <Fragment>
      <LineItem styles={styles} label="Estimated daily volume" value={formatBinaryCapacityUnit(total_cost.average_daily_volume)} />
      <LineItem styles={styles} label="Estimated annual volume" value={formatBinaryCapacityUnit(total_cost.yearly_volume)} />
    </Fragment>
  )
}

export default VolumeSummary;
